import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LL_V_L } from '@nu-art/thunderstorm-frontend';
import './Component_SL_Header.scss';
import { resolveWidth } from '../consts.js';
const getTitle = (width) => {
    const resolvedWidth = resolveWidth(width, [100, 200]);
    return _jsx("div", { className: 'csl-header-title', style: { width: resolvedWidth } });
};
const getSubtitle = (withSubtitle, width) => {
    if (!withSubtitle)
        return;
    const resolvedWidth = resolveWidth(width, [150, 250]);
    return _jsx("div", { className: 'csl-header-subtitle', style: { width: resolvedWidth } });
};
export const Component_SL_Header = (p) => {
    return _jsxs(LL_V_L, { className: 'csl-header', children: [getTitle(p.titleWidth ?? 120), getSubtitle(!!p.withSubtitle, p.subtitleWidth ?? 150)] });
};
//# sourceMappingURL=Component_SL_Header.js.map